import React from "react";
import PropTypes from "prop-types";
import PinIcon from "./PinIcon";
import { isBrandRefreshEnabled } from "../../shared/utilities/brandRefresh";
import styles from "./CookieToast.module.css";

/**
 * Add-to-cart toast under the header bag icon.
 * Brand refresh: Figma Pin+Toast (8521:78857).
 * Legacy: pink pill + cookie pin.
 */
export default function CookieToast({ count, imageUrl, isMenu }) {
  const label = `${count} ${count === 1 ? "item added" : "items added"}`;

  if (isBrandRefreshEnabled()) {
    return (
      <div
        className={styles.group}
        data-testid="cookie-toast"
        data-region="cookie-toast"
        role="status"
        aria-live="polite"
      >
        <div className={styles.pill} data-part="toast-pill">
          <p className={styles.pillText}>{label}</p>
        </div>
        <div className={styles.pin} data-part="toast-pin">
          <PinIcon
            imageUrl={imageUrl}
            rotation={180}
            circleColor="#F1E8DE"
            withShadow
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-0 relative">
      <div
        className="bg-[#E01766] text-white text-sm leading-4 font-montserratMedium font-bold
          px-4 py-3 w-[168px] h-10 flex items-center relative z-10 mt-2"
      >
        <p className="flex items-center gap-1">
          <span>{count}</span>
          <span>{count === 1 ? "item added" : "items added"}</span>
        </p>
      </div>

      <div className={`relative ${isMenu ? "-ml-10" : "-ml-12"} flex items-center z-20`}>
        <PinIcon imageUrl={imageUrl} rotation={180} />
      </div>
    </div>
  );
}

CookieToast.propTypes = {
  count: PropTypes.number.isRequired,
  imageUrl: PropTypes.string,
  isMenu: PropTypes.bool
};

CookieToast.defaultProps = {
  imageUrl: "",
  isMenu: false
};
